<mat-toolbar class="ori-elevation-z4" role="toolbar">
  <div class="left">
    <button
      mat-icon-button
      class="toc-button app-menu-button"
      [class.opened]="tocNav?.opened"
      type="button"
      title="toggle toc button"
      oPlayId
      pidValue="toggle-toc-btn"
      (click)="tocToggle()">
      <mat-icon svgIcon="menu-burger"></mat-icon>
    </button>
    <o-history-switch (click)="settingsSidenav.close()"></o-history-switch>
    @if (store.pubInfo?.capabilities?.historic) {
      <o-historic></o-historic>
    }
    <div class="du-title">
      <h3>{{ titleService.headerTitle | translate }}</h3>
      @if (titleService.headerSubtitle) {
        <h4>{{ titleService.headerSubtitle }}</h4>
      }
    </div>
  </div>

  <div class="right">
    @if (store.pubInfo?.capabilities?.sync) {
      <button mat-icon-button class="synchro-icon" type="button" title="Synchro button">
        <mat-icon [class.beyblade]="synchroService.statusIcon === 'autorenew'" [svgIcon]="synchroService.statusIcon" />
      </button>
    }
    @if (store.offlineSearchReady && !searchInURL()) {
      <button mat-icon-button class="search-button" type="button" title="Search button" (click)="search()">
        <mat-icon svgIcon="search" />
      </button>
    }
    <button mat-icon-button class="news-button" type="button" title="News button" (click)="openNewsModal()">
      <mat-icon
        aria-hidden="false"
        matBadgeSize="medium"
        [matBadge]="badgeNumber | async"
        [matBadgeHidden]="(badgeNumber | async) === 0"
        matBadgeColor="accent"
        svgIcon="bell" />
    </button>
    <button
      mat-icon-button
      class="setting-button"
      type="button"
      title="Settings button"
      oPlayId
      pidValue="setting-btn"
      [ngClass]="{ opened: settingsSidenav?.opened }"
      (click)="settingsToggle()">
      <mat-icon svgIcon="menu-kebab" />
    </button>
  </div>
</mat-toolbar>
